export function useTawk({ name, email, role }) {
  if (typeof window === 'undefined') return;

  // console.log("[Tawk] Initializing for:", name);

  if (!window.Tawk_API) {
    const s1 = document.createElement('script');
    s1.async = true;
    s1.src = 'https://embed.tawk.to/685ce27d254fe519122197dd/1iuld9euv';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    document.head.appendChild(s1);

    s1.onload = () => {
      waitForTawkToBeReady(name, email, role);
    };
  } else {
    waitForTawkToBeReady(name, email, role);
  }

  function waitForTawkToBeReady(name, email, role) {
    if (!window.Tawk_API) return;

    window.Tawk_API.onLoad = () => {
      console.log("[Tawk] Widget loaded");
      setTawkAttributes(name, email, role);
      addTawkEventListeners();
    };
  }

  function setTawkAttributes(name, email, role) {
    if (window.Tawk_API?.setAttributes) {
      window.Tawk_API.setAttributes(
        {
          name,
          email,
          role: role || 'user'
        },
        (error) => {
          if (error) {
            console.error('[Tawk] setAttributes error:', error);
          } else {
            console.log('[Tawk] Attributes set:', { name, email, role });
          }
        }
      );
    } else {
      console.warn('[Tawk] setAttributes not available yet');
    }
  }

  function addTawkEventListeners() {
    if (!window.Tawk_API) return;

    window.Tawk_API.onChatStarted = function () {
      console.log('[Tawk] Chat started');
    };

    window.Tawk_API.onChatEnded = function () {
      console.log('[Tawk] Chat ended');
    };
  }
}
